// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/ch-tap.svg';

export const ChTap = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
